<template>
  <div class="pay-setting">
    <div class="tips" v-if="disabled"><i class="iconfont icon-jinggao1"></i> 请先在“版本管理及上线”里下架应用</div>
    <el-form ref="form" :model="form" label-width="88px">
      <el-form-item label="商品类型" class="required-form-item">
        <el-radio-group v-model="form.feeType" :disabled="disabled">
          <div class="form-radio" v-for="type in types" :key="type.label">
            <el-radio :label="type.label"><span v-html="type.value"></span></el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="收费规则" v-if="form.feeType==2" class="required-form-item">
        <el-radio-group v-model="form.feeRule" :disabled="disabled">
          <div class="form-radio" v-for="rule in rules" :key="rule.label">
            <el-radio :label="rule.label"><span v-html="rule.value"></span></el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否试用" v-if="form.feeType==2" class="required-form-item">
        <el-radio-group v-model="form.trialType" :disabled="disabled">
          <div class="form-radio">
            <el-radio :label="1">{{ defaultTrialDays }}天试用期 <span>（试用价格为0元，使用人员为全公司）</span>
            </el-radio>
          </div>
          <div class="form-radio">
            <el-radio :label="2">自定义试用周期
              <el-input v-model="form.trialDays" class="day-input" :disabled="form.trialType!=2||disabled"
                        placeholder="0"></el-input>
              <span class="radio-desc">（最长90天）</span></el-radio>
          </div>
          <div class="form-radio">
            <el-radio :label="3">不支持试用</el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="套餐设置" v-if="form.feeType==2" class="required-form-item " label-position="top">
        <div class="layout feepackages-add">
          <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="addTable" v-if="!disabled">新增套餐
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <div class="table-block" v-if="form.feeType==2">
      <new-table :data="form.feePackages.filter(item=>!item.isDelete)" :columns="columns" :pages="false"></new-table>
    </div>
    <div class="footer-btn">
      <el-button type="primary" @click="save" v-if="!disabled">保存设置</el-button>
    </div>
  </div>
</template>
<script>
import paySettingService from "../../apis/paySettingService";
import orderService from "../../apis/orderService";
import newTable from "../../components/new-table"

export default {
  props: {
    applicationId: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {newTable},
  data() {
    return {
      d_types: [
        {label: 1, value: `免费应用 <span >（用户开通应用免费）</span>`},
        {label: 2, value: `收费应用 <span>（用户开通应用需要收取费用）</span>`},
      ],
      types: [],
      rules: [
        // {label: 1, value: `按企业通讯录人数收费 <span class="radio-desc">（根据企业通讯录人数范围，如1～50人）</span>`},
        {label: 2, value: `按使用人数进行收费 <span >（根据应用的使用人员数来设置设定价格）</span>`},
        // {label: 3, value: `按单个使用人数收费 <span class="radio-desc">（如：20元/人/年）</span>`},
      ],
      defaultTrialDays: 15,//通用配置的试用天数
      form: {
        feeType: 1,//1 免费应用 2收费应用
        feeRule: 2,//2 按使用人数收费
        trialType: 1,//是否试用
        trialDays: 0,//试用天数
        feePackages: [],//套餐列表
      },
      columns: [
        {
          label: "SKU", prop: "sku", "min-width": '100px',
          render: (h, scope) => {
            if (isNaN(scope.row.maxUsers) || isNaN(scope.row.months)) return "S-U-M";
            scope.row.sku = `S-${scope.row.maxUsers >= 0 ? scope.row.maxUsers : ""}U-${scope.row.months || ''}M`;
            return (
                <div>
                  <div on={{
                    "click": () => {
                      this.cellClick({edit: false}, scope.row)
                    }
                  }}><span>{scope.row.sku}</span>
                  </div>
                </div>
            )
          },
        },
        {
          label: "套餐名称", prop: "name", "min-width": "145", placeholder: '请输入套餐名称',
          render: (h, scope) => {
            if (scope.row.edit) {
              return (
                  <div>
                    <el-input v-model={scope.row.name} placeholder="请输入套餐名称" maxlength="20"></el-input>
                  </div>
              )
            } else {
              return (
                  <div on={{
                    "click": () => {
                      this.cellClick({edit: true}, scope.row)
                    }
                  }}><span>{scope.row.name}</span>
                  </div>
              )
            }
          }
        },
        {
          label: "最大用户数",
          prop: "maxUsers",
          placeholder: '请输入用户数',
          "min-width": '90px',
          render: (h, scope) => {
            if (scope.row.edit) {
              return (
                  <div>
                    <el-input-number v-model={scope.row.maxUsers}
                                     style="width:110px"
                                     disabled={scope.row.id > 0}
                                     min={1}
                                     max={999999999}
                                     controls={false}
                                     step={1}
                                     step-strictly
                                     placeholder="请输入用户数"></el-input-number>
                  </div>
              )
            } else {
              return (
                  <div on={{
                    "click": () => {
                      this.cellClick({edit: true}, scope.row)
                    }
                  }}><span>{scope.row.maxUsers}</span>
                  </div>
              )
            }
          },
        },
        {
          label: "周期(月)",
          prop: "months",
          placeholder: '请输入周期',
          "min-width": '90px',
          render: (h, scope) => {
            if (scope.row.edit) {
              return (
                  <div>
                    <el-input-number v-model={scope.row.months}
                                     style="width:100px"
                                     disabled={scope.row.id > 0}
                                     min={1}
                                     max={99}
                                     controls={false}
                                     step={1}
                                     step-strictly
                                     placeholder="请输入周期"
                                     on={{
                                       'blur': () => {
                                         scope.row.packagePrice = (scope.row.months * scope.row.pricePerMonth) || ''
                                       }
                                     }}
                    ></el-input-number>
                  </div>
              )
            } else {
              return (
                  <div on={{
                    "click": () => {
                      this.cellClick({edit: true}, scope.row)
                    }
                  }}><span>{scope.row.months}</span>
                  </div>
              )
            }
          },
        },
        {
          label: "单价（元/月）",
          prop: "pricePerMonth",
          placeholder: '请输入单价',
          "min-width": '90px',
          render: (h, scope) => {
            if (scope.row.edit) {
              return (
                  <div>
                    <el-input-number v-model={scope.row.pricePerMonth}
                                     style="width:100px"
                                     min={1}
                                     max={99999}
                                     controls={false}
                                     step={1}
                                     step-strictly
                                     placeholder="请输入单价"
                                     on={{
                                       'blur': () => {
                                         scope.row.packagePrice = (scope.row.months * scope.row.pricePerMonth) || ''
                                       }
                                     }}
                    ></el-input-number>
                  </div>
              )
            } else {
              return (
                  <div on={{
                    "click": () => {
                      this.cellClick({edit: true}, scope.row)
                    }
                  }}><span>{scope.row.pricePerMonth}</span>
                  </div>
              )
            }
          },
        },
        {
          label: "套餐售价（元）", prop: "packagePrice", "min-width": '100px',
          render: (h, scope) => {
            if (scope.row.edit) {
              return (
                  <div>
                    <el-input v-model={scope.row.packagePrice}
                              style="width:100px"
                              disabled
                    ></el-input>
                  </div>
              )
            } else {
              if (scope.row.packagePrice && !scope.row.edit) {
                return (
                    <div on={{
                      "click": () => {
                        this.cellClick({edit: false}, scope.row)
                      }
                    }}><span>{orderService.toYuan(scope.row.packagePrice)}</span>
                    </div>
                )
              }
            }
          },
        },
        {
          label: "操作", "min-width": "80px",
          render: (h, scope) => {
            return (
                <div>
                  <el-button class="del-btn"
                             size="small"
                             disabled={this.disabled}
                             on={{
                               'click': () => {
                                 this.del(scope.row, scope.$index)
                               }
                             }}>删除
                  </el-button>
                </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    async getAppChargeSetInfo() {
      const res = await paySettingService.getAppChargeSetInfo()
      if (!res.isCharge) {
        this.types = [this.d_types[0]]
      } else {
        this.types = this.d_types
      }
    },
    async getGlobalSetting() {
      const res = await paySettingService.getGlobalSetting();
      this.defaultTrialDays = res.defaultTrialDays || 15;
    },
    addTable() {
      this.form.feePackages.push({
        sku: '',
        name: '',
        maxUsers: undefined,
        months: undefined,
        pricePerMonth: undefined,
        packagePrice: '',
        edit: true
      })
    },
    del(row, index) {
      this.$confirm('确定要删除该套餐吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(row, "isDelete", true);
        if (!row.id) this.form.feePackages.splice(index, 1);
      }).catch(() => {

      });
    },

    checkFeePackages() {//校验
      if (this.form.trialDays.toString().match(/[^0-9]/g) || this.form.trialDays > 90) {
        this.form.trialDays = 0;
        throw "请输入不超过90的整数天"
      }
      if (this.form.feeType == 2 && !this.form.feePackages.filter(row => !row.isDelete).length) throw `收费应用至少需要添加一项套餐`;
      if (this.form.trialType == 3) this.form.trialDays = 0;
      if (this.form.trialType == 1) this.form.trialDays = this.defaultTrialDays;
      if (this.form.trialType == 2 && !this.form.trialDays) throw `请输入不超过90的整数天`;
      this.form.feePackages.forEach(row => {
        if (row.isDelete) return;
        this.columns.forEach(column => {
          if (!row[column.prop] && column.placeholder) throw column.placeholder;
          // if (column.validate) column.validate(row, this.form.feePackages);
        })
      })
    },
    async save() {
      try {
        this.checkFeePackages();
      } catch (e) {
        return this.$message.warning(e);
      }
      const feePackages = this.form.feePackages.map(item => {
        return {
          ...item,
          maxUsers: Number(item.maxUsers),
          months: Number(item.months),
          pricePerMonth: orderService.toFen(item.pricePerMonth),
          packagePrice: orderService.toFen(item.packagePrice)
        };
      })
      await paySettingService.saveApplicationFeeInfo({...this.form, feePackages});
      this.getFeeInfo();
      this.$message.success("保存成功");

    },
    async getFeeInfo() {
      const res = await paySettingService.getApplicationFeeInfo(this.form.applicationId);
      // 设置默认值（免费保存后切换到收费，默认值null，页面数据残留）
      if (res.trialType === null) res.trialType = 1;
      if (res.trialDays === null) res.trialDays = 0;
      if (res.feeRule == null) res.feeRule = 2;

      res.feePackages.forEach(fee => {
        fee.edit = false;
        fee.pricePerMonth = orderService.toYuan(fee.pricePerMonth)
      })
      Object.assign(this.form, res);
      this.trialDaysTips();
    },
    trialDaysTips() {
      if (this.form.feeType == 2 && this.form.trialType == 1 && this.form.trialDays != this.defaultTrialDays && !this.disabled) {
        this.$alert(`系统默认试用时间有调整，自动为您变更为‘自定义试用周期’`, '提示', {
          confirmButtonText: '确定'
        }).then(res => {
          this.form.trialType = 2;
        });
      }
    },
    cellClick(column, row) {
      if (!column.edit || row.edit || this.disabled) return;
      this.$set(row, "edit", true);
    }

  },
  async mounted() {
    this.form.applicationId = this.applicationId;
    await this.getAppChargeSetInfo()
    await this.getGlobalSetting();
    this.getFeeInfo();
  }
}
</script>
<style lang='scss' scoped>
.pay-setting {
  width: 936px;
  overflow: auto;
  .tips {
    font-size: 12px;
    color: rgba(70, 70, 70, 0.65);

    i {
      color: red;
      font-size: 12px;
      margin-right: 5px;
      display: inline-block;
      transform: scale(.8);
    }
  }

  ::v-deep .required-form-item {
    .el-form-item__label {
      position: relative;

      &:after {
        content: "*";
        color: red;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  ::v-deep .el-form-item__label {
    font-size: 14px;
  }

  ::v-deep .form-radio {
    line-height: 22px;
    margin-bottom: 20px;

    &:first-of-type {
      margin-top: 10px;
    }

    .el-radio__label {
      color: #333;
    }

    .radio-desc {
      color: #999;
    }

    .day-input {
      width: 56px;
      height: 24px;

      .el-input__inner {
        height: 24px;
        line-height: 24px;
      }
    }
  }

  .feepackages-add {
    justify-content: flex-end;

    .el-button--primary.is-plain {
      background-color: #fff;
      border-color: rgba(24, 144, 255, 1);
      width: 113px;

      &:hover, &:active, &:focus {
        color: rgba(24, 144, 255, 1);
      }

    }
  }

  .table-block {
    margin-top: 15px;

    ::v-deep .del-btn {
      border: none;
      background: transparent;

      span {
        color: #fa5d5f;

      }

    }

    ::v-deep .el-input__inner {
      border: 0;
      outline: none;
      background-color: rgba(240, 240, 240, 1);
      margin: 2px;
    }
  }

  .footer-btn {
    margin-top: 30px;

    .el-button {
      width: 406px;
      height: 50px;
    }
  }

  ::v-deep .el-table__body-wrapper {
    height: auto !important;
  }
}
</style>
